export default "__VITE_ASSET__C7Uq3GEA__"